import './InputButton.scss';

function InputButton({type}){

    return (
        <input className="inputButton" type={type} />
    )
}

export default InputButton;